/**
 * The first user message the nav's "Create ..." links send into a new chat
 * thread. The agent does the creating; these only open the conversation.
 */
export const CHAT_STARTERS = {
  initiative:
    'I want to create a new initiative. Ask me what I need to tell you, one question at a time.',
  idea: 'I have an idea I want to record. Ask me what it is, then help me write it up as an idea.',
} as const
